import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import { Select, Tooltip } from 'antd';
import block from './block.js';
const blocks = {};

function anyAscii(string) {
    // 中文直接返回
    if (/.*[\u4e00-\u9fa5]+.*$/.test(string)) {
        return string;
    }
    let result = '';
    for (const c of string) {
        const codePoint = c.codePointAt(0);
        if (codePoint <= 0x7f) {
            result += c;
            continue;
        }
        const blockNum = codePoint >>> 8;
        const lo = codePoint & 0xff;
        let b = blocks[blockNum];
        if (b === undefined) {
            blocks[blockNum] = b = block(blockNum).split("\t");
        }
        if (b.length > lo) {
            result += b[lo];
        }
    }
    return result;
}

class Selector extends Component {

    render() {
        const { placeholder, mode, selectLock, name, defaultValue, selectorValues, changeSelector, selectedValue, warning, allowClear, onClear, value, size, title, style } = this.props;
        let v = selectedValue;
        if (v == 0 || v == undefined) {
            if (typeof (v) != 'object') {
                v = '0';
            }
        } else {
            if (typeof (v) != 'object') {
                v = v.toString();
            }
        }

        return (
            <FormGroup controlId={'formControlsSelect' + name} bsSize='small' className={warning} style={style}>
                <Tooltip title={title ? title : ''} arrow={false} placement="left" mouseEnterDelay={0} mouseLeaveDelay={0}>
                {value ?
                    <Select
                        size={size ? size : 'middle'}
                        mode={mode ? mode : null}
                        allowClear={allowClear ? true : false}
                        showSearch
                        status={warning ? 'error' : null}
                        style={{ width: "100%", minWidth: "150px" }}
                        componentClass="select"
                        placeholder={placeholder ? placeholder : 'select'}
                        optionFilterProp="children"
                        onChange={changeSelector}
                        onClear={onClear ? onClear : () => { }}
                        key={v}
                        defaultValue={v}
                        value={value}
                        filterOption={(input, option) => {
                            return option.keyword ? anyAscii(option.keyword).toLowerCase().indexOf(input.toLowerCase()) >= 0 : false
                        }
                        }
                    >
                        {typeof (defaultValue) == 'object' ? null : <option keyword={defaultValue} value="0">{defaultValue}</option>}
                        {
                            (selectorValues) ? selectorValues.map(option => (
                                <Option keyword={option.searchText || option.label || option.name} key={option.id} disabled={selectLock ? false : (option.lock ? true : false)}>{option.label || option.name} {option.lock ? '🔒' : ''}</Option>
                            )) : null
                        }
                    </Select>
                    :
                    <Select
                        size={size ? size : 'middle'}
                        mode={mode ? mode : null}
                        allowClear={allowClear ? true : false}
                        showSearch
                        status={warning ? 'error' : null}
                        style={{ width: "100%", minWidth: "150px" }}
                        componentClass="select"
                        placeholder={placeholder ? placeholder : 'select'}
                        optionFilterProp="children"
                        onChange={changeSelector}
                        onClear={onClear ? onClear : () => { }}
                        key={v}
                        defaultValue={v}
                        filterOption={(input, option) => {
                            return option.keyword ? anyAscii(option.keyword).toLowerCase().indexOf(input.toLowerCase()) >= 0 : false
                        }
                        }
                    >
                        {typeof (defaultValue) == 'object' ? null : <option keyword={defaultValue} value="0">{defaultValue}</option>}
                        {
                            (selectorValues) ? selectorValues.map(option => (
                                <Option keyword={option.searchText || option.label || option.name} key={option.id} disabled={selectLock ? false : (option.lock ? true : false)}>
                                    <Tooltip arrow={false} title={(name == 'ztn_id') ? option.remark : ''} placement="right" mouseEnterDelay={0} mouseLeaveDelay={0}>
                                        {option.label || option.name} {option.lock ? '🔒' : ''}
                                        {(name == 'ztn_id' && option.problem) ? '🔒' : ''}
                                    </Tooltip>
                                </Option>
                            )) : null
                        }
                    </Select>
                }
                </Tooltip>
            </FormGroup>
        );
    }
}

export default Selector;
